import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Donate from './pages/Donate';
import Dedications from './pages/Dedications';
import Bricks from './pages/Bricks';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Test from './pages/Test';
import UpdateTotal from './pages/UpdateTotal';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function AppContent() {
  const { pathname } = useLocation();
  const isUtilityPage = pathname === '/update-total' || pathname === '/total';

  return (
    <div className="min-h-screen bg-[#f6f7f3]">
      <ScrollToTop />
      {!isUtilityPage && <Navbar />}
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/dedications" element={<Dedications />} />
          <Route path="/bricks" element={<Bricks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/update-total" element={<UpdateTotal />} />
          <Route path="/total" element={<UpdateTotal />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/test" element={<Test />} />
        </Routes>
      </AnimatePresence>
      {!isUtilityPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppContent />
    </Router>
  );
}

export default App; 
